/**
 * Ad Create Module
 */
import _ from 'lodash';
import * as types from 'src/store/types';

// 初始化数据
const initState = {
  loading: false,
  showSelectModal: false,
  actionOptions: [],
  adCopiedInfo: {},
};

const state = {
  ..._.cloneDeep(initState),

  // 用于重置数据时候调用
  initState,
};

const getters = {};

const mutations = {
  [types.SET_LOADING_STATE](state, { status }) {
    state.loading = status;
  },

  [types.SET_SELECT_MODAL_STATE](state, { status }) {
    state.showSelectModal = status;
  },

  [types.SET_ACTION_OPTIONS](state, { actionOptions }) {
    state.actionOptions = actionOptions;
  },

  [types.COPY_AD](state, adCopiedInfo) {
    state.adCopiedInfo = adCopiedInfo;
  },

  [types.RESET_STATES](state) {
    for (const item of Object.keys(state)) {
      if (_.has(state.initState, item)) {
        state[item] = state.initState[item];
      }
    }
  },
};

const actions = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
